module.exports = __webpack_public_path__ + "static/media/playstore_catchphrase_1024x500.a58ed40d.jpeg";